import { getWhichOAuthLoading } from '../../store/app/selectors';
export const isOAuthLoading = (state, provider) => {
  const loadingOAuthProvider = getWhichOAuthLoading(state);
  return loadingOAuthProvider === provider;
};